import { AxiosInstance } from "../../axios/axiosInstance"
import { apiRoutes } from "../../utils/ApiRoutes"

export const GetCategoriesApi = async (business_id: string) => {
    const response = await AxiosInstance.post(apiRoutes?.getcategories, { business_id })
    return response
}

export const CreateCategoriesApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.createcategories, { categories: payload?.categories, business_id: payload?.checkin_id })
    return response
}

export const DeleteCategoriesApi = async (payload: any) => {
    const response = await AxiosInstance.post(apiRoutes?.deletecategories, { categories: payload?.categories, business_id: payload?.checkin_id })
    return response
}